import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import { gql } from '@apollo/client';
import { makeDecodedQuery } from '@infl-ts/util-make-apollo-decoded';
import { logQueryError } from '@infl-ts/util-query-errors';
import { Box } from '@mui/material';
import * as DE from '@nll/datum/lib/DatumEither';
import { flow, pipe } from 'fp-ts/function';
import * as t from 'io-ts';
import { Profile } from '../codecs';
import OnboardingError from '../onboarding-error';
import OnboardingModal from './onboarding-modal';
import { jsx as _jsx } from "react/jsx-runtime";
var useWelcomeOnboarding = makeDecodedQuery(gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    query WelcomeOnboarding {\n      profile {\n        id\n        username\n        name\n        email\n        title\n        company\n        avatarUrl\n      }\n    }\n  "]))), t.type({
  profile: Profile
}));

var WelcomeMessageFlow = function WelcomeMessageFlow(_ref) {
  var onboardingWelcomeFlow = _ref.onboardingWelcomeFlow;
  return pipe(useWelcomeOnboarding(), DE.squash(function () {
    return /*#__PURE__*/_jsx(Box, {});
  }, flow(logQueryError, function () {
    return /*#__PURE__*/_jsx(OnboardingError, {});
  }), function (_ref2) {
    var profile = _ref2.profile;
    return /*#__PURE__*/_jsx(OnboardingModal, {
      welcomeMessage: onboardingWelcomeFlow.message,
      profile: profile
    });
  }));
};

export default WelcomeMessageFlow;